/**
 *
 * 方案汇报 - 绕点飞行 1.0
 *
 * 功能点:根据预设点绕点飞行
 * 场景:方案汇报
 *
 */
import Vue from "@/main";
import { rotatePointData } from "@/components/tables/program/static-data.js";

let rotatePoint = null;

export function init() {
  if (!rotatePoint) {
    stopRotate();
    rotatePoint = new mars3d.thing.RotatePoint({
      direction: false, // 方向 true逆时针，false顺时针
      time: 50,
    });
    Vue.$GLOBAL.map.addThing(rotatePoint);
  }
}

export function handleRotateView(type, id) {
  if (!rotatePoint) return;

  switch (type) {
    case "start":
      startRotate(id);
      break;
    case "stop":
      stopRotate();
      break;
    default:
      break;
  }
}

export function destroyed() {
  if (rotatePoint) {
    Vue.$GLOBAL.map.removeThing(rotatePoint, true);
    rotatePoint = null;
  }
}

function startRotate(id) {
  stopRotate();
  // if (rotatePointData[id]) rotatePoint.distance = rotatePointData[id].alt;

  // Vue.$GLOBAL.map.setSceneOptions({
  //   center: {
  //     lng: rotatePointData[id].lng,
  //     lat: rotatePointData[id].lat,
  //     alt: rotatePointData[id].alt,
  //     heading: rotatePointData[id].heading,
  //     pitch: rotatePointData[id].pitch,
  //     roll: rotatePointData[id].roll,
  //   },
  // });

  let point = Vue.$GLOBAL.map.getCenter();
  console.log("中心点", point);
  rotatePoint.start(point);
}

function stopRotate() {
  console.log("暂停？");
  if (!rotatePoint) return;
  if (rotatePoint.isStart == true) rotatePoint.stop();
}
